import React, { useState, useRef } from 'react';
import {
  Box, Button, FormControl, FormLabel, Slider, Switch,
  FormGroup, FormControlLabel, Tooltip
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import io from 'socket.io-client';
import { useTranslation } from 'react-i18next';
import MeditationCreditGauge from '../ai/MeditationCreditGauge'; // 🔁 Assure-toi que le chemin est bon

const backendUrl = process.env.REACT_APP_BACKEND_URL;
let socket = io(backendUrl);

const MeditationSettings = ({ roomCode, onSubmit }) => {
  const { currentUser } = useAuth();
  const { t } = useTranslation();
  const [meditationType, setMeditationType] = useState('guided');
  const [soundBackground, setSoundBackground] = useState(false);
  const [duration, setDuration] = useState(5);
  const creditGaugeRef = useRef(null); // pour rafraîchir plus tard si besoin

  const allowedDurations = [5, 10, 15, 20, 25, 30];

  const closestAllowedValue = (value) => {
    return allowedDurations.reduce((prev, curr) =>
      Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
    );
  };

  const handleSubmit = () => {
    const settings = {
      meditationType,
      soundBackground,
      duration
    };

    onSubmit(settings);

    socket.emit('inviteToMeditate', {
      room: roomCode,
      senderId: currentUser.userId
    });

    socket.emit('updateMeditationSettings', {
      room: roomCode,
      settings
    });

    // Facultatif : rafraîchir les crédits
    creditGaugeRef.current?.refreshCredits?.();
  };

  return (
    <Box sx={{ p: 3 }}>

      <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 1, mb: 0.5 }}>
        <FormControl component="fieldset" sx={{ mb: 2, textAlign: 'center' }}>
          <FormLabel sx={{ fontSize: '1.2em', fontWeight: 'bold', color: 'black' }} component="legend">
            {t('guided_meditation')}
          </FormLabel>
          <FormGroup>
            <Tooltip title={t('toggle_meditation_type')} arrow>
              <FormControlLabel
                control={
                  <Switch
                    checked={meditationType === 'guided'}
                    onChange={() =>
                      setMeditationType(meditationType === 'guided' ? 'free' : 'guided')
                    }
                  />
                }
                label={
                  <Box sx={{ width: '25px', textAlign: 'center', mr: 0 }}>
                    {meditationType === 'guided' ? t('yes') : t('no')}
                  </Box>
                }
              />
            </Tooltip>
          </FormGroup>
        </FormControl>

        <FormControl component="fieldset" sx={{ mb: 2, textAlign: 'center' }}>
          <FormLabel sx={{ fontSize: '1.2em', fontWeight: 'bold', color: 'black' }} component="legend">
            {t('background_sound')}
          </FormLabel>
          <FormGroup>
            <Tooltip title={t('toggle_background_sound')} arrow>
              <FormControlLabel
                control={
                  <Switch
                    checked={soundBackground}
                    onChange={() => setSoundBackground(!soundBackground)}
                  />
                }
                label={
                  <Box sx={{ width: '25px', textAlign: 'center', mr: 0 }}>
                    {soundBackground ? t('yes') : t('no')}
                  </Box>
                }
              />
            </Tooltip>
          </FormGroup>
        </FormControl>
      </Box>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <Box sx={{ mx: 3 }}>
          <Slider
            value={duration}
            onChange={(e, newValue) => setDuration(newValue)}
            onChangeCommitted={(e, newValue) => setDuration(closestAllowedValue(newValue))}
            step={null}
            marks={allowedDurations.map(value => ({ value, label: `${value}m` }))}
            min={3}
            max={30}
          />
        </Box>
      </FormControl>

      <Button variant="contained" color="primary" sx={{ fontSize: '1.2em', display:"block" }} fullWidth onClick={handleSubmit}>
        
      <Box sx={{  mb:0.3 }}>{t('start_meditate')}</Box>
        
      {/* 🔥 Jauge de crédits méditation */}
      <Box sx={{ display: 'flex', justifyContent: 'center'}}>
        <MeditationCreditGauge ref={creditGaugeRef} />
      </Box>

      </Button>



    </Box>
  );
};

export default MeditationSettings;
